import { Space, Table } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomUserTableProps } from './type';

const CustomTable: FC<CustomUserTableProps> = (props) => {
	const { Column } = Table;
	const {
		dataSource,
		subCategoryRows,
		emptyTableMessage,
		isLoading,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditSelectedSubCategory,
		showModal,
		selectedCategory,
		setSelectedCategory,
	} = props;

	const userPermissions = useSelector((state: any) => state?.userProfile);

	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'GrocerySubCategories',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'GrocerySubCategories',
		permission: ['delete'],
	});

	const editDataHandler = (categoryObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Sub Category');
		setEditSelectedSubCategory(categoryObject);
	};

	const deleteDataHandler = (categoryObject: any) => {
		setEditSelectedSubCategory(categoryObject);
		showModal();
	};

	return (
		<div className={`${styles['body']} subCategory-table-pagination `}>
			<SearchAndFilter
				title="Sub Category List"
				openDrawerHandler={openDrawerHandler}
				categoryData={dataSource}
				selectedCategory={selectedCategory}
				setSelectedCategory={setSelectedCategory}
			/>

			<Table
				rowKey={(record) => record.id}
				dataSource={subCategoryRows}
				pagination={false}
				loading={isLoading}
				scroll={{ y: 'calc(100vh - 300px)' }}
				locale={{ emptyText: emptyTableMessage }}
			>
				<Column
					title={<p style={{ padding: '0 0px' }}>Sub Category Name</p>}
					dataIndex="name"
					key="name"
					className="subCategory-column bg-white"
					width="15%"
					sorter={(a: { name: string }, b: { name: string }) =>
						(a.name ?? '').localeCompare(b.name ?? '')
					}
					render={(value: string) => <div>{value}</div>}
				/>
				{(isEditPermission || isDeletePermission) && (
					<Column
						title="Action"
						dataIndex="action"
						key="action"
						className="bg-white"
						width="15%"
						render={(_value, data: any) => (
							<Space size={20}>
								{isEditPermission ? (
									<div
										className="cursor-pointer flex align-center justify-center rounded-action-btn"
										onClick={() => editDataHandler(data)}
									>
										<EditActionSvg />
									</div>
								) : (
									<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">
										<EditActionSvg />
									</div>
								)}

								{isDeletePermission ? (
									<div
										className="cursor-pointer flex align-center justify-center rounded-action-btn "
										onClick={() => deleteDataHandler(data)}
									>
										<DeleteActionSvg />
									</div>
								) : (
									<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
										<DeleteActionSvg />
									</div>
								)}
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default CustomTable;
